export default "__VITE_ASSET__CTP2DKDF__"